// extracted by mini-css-extract-plugin
export var messageSideLeft = "_hw-1";
export var messageSideRight = "_hw-2";
export var orderLookupBubbleContainer = "_hw-0";
export var submitButton = "_hw-3";